import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// The top nav's bell. There are no notifications today, so the panel says so;
// the bell stays grey, with no unread dot, until there is something to read.

const BellIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M9.84615 24C11.2 24 12.3077 22.8923 12.3077 21.5385H7.38462C7.38462 22.8923 8.48 24 9.84615 24ZM17.2308 16.6154V10.4615C17.2308 6.68308 15.2123 3.52 11.6923 2.68308V1.84615C11.6923 0.824615 10.8677 0 9.84615 0C8.82462 0 8 0.824615 8 1.84615V2.68308C4.46769 3.52 2.46154 6.67077 2.46154 10.4615V16.6154L0 19.0769V20.3077H19.6923V19.0769L17.2308 16.6154Z"
      fill="currentColor"
    />
  </svg>
);

const NotificationsMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      )
        setOpen(false);
    };
    const onEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onEscape);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onEscape);
    };
  }, []);

  return (
    <div ref={wrapperRef} className="relative flex items-center">
      <button
        type="button"
        data-testid="NotificationsMenu-trigger"
        aria-label={t('Notifications')}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
        className="relative flex items-center text-ui-text-disabled hover:opacity-80"
      >
        <BellIcon />
      </button>

      <div
        className={
          !open
            ? 'hidden'
            : 'absolute right-0 top-full z-30 mt-2 w-[320px] overflow-hidden rounded bg-white shadow-dropdown'
        }
        data-testid="NotificationsMenu-panel"
      >
        <div className="border-b border-ui-divider-lines px-4 py-2.5 text-body-sm font-bold text-ui-text-primary-text">
          {t('Notifications')}
        </div>
        <p
          className="px-4 py-3 text-body-sm text-ui-text-secondary-text"
          data-testid="NotificationsMenu-empty"
        >
          {t('No notifications at this time.')}
        </p>
      </div>
    </div>
  );
};

export default NotificationsMenu;
